import React from 'react';
import { Icon } from 'b3';
import {connect} from 'react-redux';
import NoteModal from '../../NoteModal';
import ConfirmDeleteNoteModal from '../../ConfirmDeleteNoteModal';
import UserAvatar from '../../UserAvatar';
import FergusLogo from '../../FergusLogo';
import { parseMentionsWithAnchor } from '../../../utils/StringUtils';
import TimelineItem from './TimelineItem';

@connect(
    state => ({ users: state.users })
)
export default class NoteTimelineItem extends React.Component {
    confirmDeleteNote() {
        this.props.openModal(ConfirmDeleteNoteModal, {noteId: this.props.id});
    }

    editNote(e) {
        this.props.openModal(NoteModal, {
            initialText: this.props.note,
            noteId: this.props.id,
            clientId: this.props.clientId
        });
    }

    render() {
        var user = this.props.users.users.find(user => user.id === this.props.createdBy);
    	var icon 	= <Icon icon="note-paper-2" />;
    	var avatar = user ? <UserAvatar user={user} /> : <FergusLogo className="avatar" />;

        return (
            <TimelineItem
            	type="note"
            	typeLabel="Note"
            	avatar={avatar}
            	icon={icon}
                openDeleteModal={this.confirmDeleteNote.bind(this)}
                openEditModal={this.editNote.bind(this)}
            >
            	<span dangerouslySetInnerHTML={{__html: parseMentionsWithAnchor(this.props.note)}}></span>
            </TimelineItem>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/NoteTimelineItem.js